module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_3016.c7b04907.png";